"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarkCongif = void 0;
const cf_1 = require("./cf");
exports.DarkCongif = Object.assign(Object.assign({}, cf_1.CFConfig), { name: "Dark", textColor: cf_1.CFConfig.bgColor, bgColor: cf_1.CFConfig.textColor });
//# sourceMappingURL=dark.js.map